import * as React from "react";
import { SVGProps } from "react";

const SupportSVG: React.FC<SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h6.691l1.444 2.5L12 24l.865-1.5L14.31 20H21a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm0 1.5h18A1.5 1.5 0 0 1 22.5 3v14a1.5 1.5 0 0 1-1.5 1.5h-7.557l-.433.75L12 21l-1.01-1.75-.433-.75H3A1.5 1.5 0 0 1 1.5 17V3A1.5 1.5 0 0 1 3 1.5zM12 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1 1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm0 4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1 1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z"
    />
  </svg>
);

export default SupportSVG;
